// extracted by mini-css-extract-plugin
module.exports = {"root":"FormError_root__5C_6R","root--global":"FormError_root--global__tjdH_","label":"FormError_label__tBMJL","rotation":"FormError_rotation__SI7y9"};